import { GymaholicLogoLink } from 'components/Icon/icons/gymaholic'
import { View } from 'components/View'
import React from 'react'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'

export default function HeaderLogo () {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  return (
    <View
      style={{
        position: 'relative',
        minWidth: '4.44em',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        color: '#191919',
        flexGrow: isSmallScreen
          ? 1
          : null
      }}
    >
      <GymaholicLogoLink />
    </View>
  )
}
